export default "__VITE_ASSET__B3x5_G7d__"